"use client";

import { useState } from "react";

type TabId = "brew" | "pip" | "choco" | "docker";

interface Tab {
  id: TabId;
  label: string;
  icon: React.ReactNode;
  command: string;
  note?: string;
}

const tabs: Tab[] = [
  {
    id: "brew",
    label: "Homebrew",
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M5.556 0a.5.5 0 0 1 .5.5V2h2V.5a.5.5 0 0 1 1 0V2h2V.5a.5.5 0 0 1 1 0V2h2V.5a.5.5 0 0 1 1 0V2h2V.5a.5.5 0 1 1 1 0V2h.056c1.122 0 2 .878 2 2v.5a.5.5 0 1 1-1 0V4c0-.565-.435-1-1-1h-.056v1.5a.5.5 0 1 1-1 0V3h-2v1.5a.5.5 0 1 1-1 0V3h-2v1.5a.5.5 0 0 1-1 0V3h-2v1.5a.5.5 0 0 1-1 0V3h-2v1.5a.5.5 0 0 1-1 0V3h-.056c-.565 0-1 .435-1 1v.5a.5.5 0 0 1-1 0V4c0-1.122.878-2 2-2h.056V.5a.5.5 0 0 1 .5-.5zM3.5 6v14c0 2.21 1.79 4 4 4h9c2.21 0 4-1.79 4-4V6h-17zm4 2h9c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1h-9c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1z"/>
      </svg>
    ),
    command: "brew install shivasurya/tap/pathfinder",
    note: "macOS & Linux • v2.1.0",
  },
  {
    id: "pip",
    label: "pip",
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12.293 1.122L3.564 6.286a1.498 1.498 0 0 0-.764 1.31v10.277c0 .537.286 1.033.751 1.3l8.165 4.693a1.494 1.494 0 0 0 1.506.007l8.729-4.914a1.5 1.5 0 0 0 .771-1.314V6.598a1.497 1.497 0 0 0-.75-1.299l-8.893-5.177a1.498 1.498 0 0 0-1.786.001zm.993 1.189a.503.503 0 0 1 .502-.002l8.893 5.177a.5.5 0 0 1 .25.433v11.047a.5.5 0 0 1-.257.438l-8.729 4.914a.498.498 0 0 1-.502-.002L4.278 19.623a.5.5 0 0 1-.25-.433V8.913a.5.5 0 0 1 .255-.437l8.729-6.165z"/>
      </svg>
    ),
    command: "pip install codepathfinder",
    note: "Python 3.8+ • Includes CLI & Python SDK",
  },
  {
    id: "choco",
    label: "Chocolatey",
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M2.5 0A2.5 2.5 0 0 0 0 2.5v19A2.5 2.5 0 0 0 2.5 24h19a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 21.5 0h-19zm8.965 3.652c.297 0 .595.05.883.15 1.142.388 1.8 1.632 1.467 2.777-.332 1.145-1.573 1.806-2.715 1.418a2.284 2.284 0 0 1-1.467-2.777c.264-.913 1.087-1.568 2.025-1.568h.807zm6.54 0c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807zm-13.08 6.54c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807zm6.54 0c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807zm6.54 0c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807zm-9.81 6.54c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807zm6.54 0c.938 0 1.76.655 2.025 1.568.333 1.145-.325 2.39-1.467 2.777-1.142.388-2.383-.273-2.715-1.418-.332-1.145.325-2.39 1.467-2.777a2.284 2.284 0 0 1 .883-.15h.807z"/>
      </svg>
    ),
    command: "choco install code-pathfinder",
    note: "Windows • Administrator access required",
  },
  {
    id: "docker",
    label: "Docker",
    icon: (
      <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M13.983 11.078h2.119a.186.186 0 0 0 .186-.185V9.006a.186.186 0 0 0-.186-.186h-2.119a.185.185 0 0 0-.185.185v1.888c0 .102.083.185.185.185m-2.954-5.43h2.118a.186.186 0 0 0 .186-.186V3.574a.186.186 0 0 0-.186-.185h-2.118a.185.185 0 0 0-.185.185v1.888c0 .102.082.185.185.186m0 2.716h2.118a.187.187 0 0 0 .186-.186V6.29a.186.186 0 0 0-.186-.185h-2.118a.185.185 0 0 0-.185.185v1.887c0 .102.082.185.185.186m-2.93 0h2.12a.186.186 0 0 0 .184-.186V6.29a.185.185 0 0 0-.185-.185H8.1a.185.185 0 0 0-.185.185v1.887c0 .102.083.185.185.186m-2.964 0h2.119a.186.186 0 0 0 .185-.186V6.29a.185.185 0 0 0-.185-.185H5.136a.186.186 0 0 0-.186.185v1.887c0 .102.084.185.186.186m5.893 2.715h2.118a.186.186 0 0 0 .186-.185V9.006a.186.186 0 0 0-.186-.186h-2.118a.185.185 0 0 0-.185.185v1.888c0 .102.082.185.185.185m-2.93 0h2.12a.185.185 0 0 0 .184-.185V9.006a.185.185 0 0 0-.184-.186h-2.12a.185.185 0 0 0-.184.185v1.888c0 .102.083.185.185.185m-2.964 0h2.119a.185.185 0 0 0 .185-.185V9.006a.185.185 0 0 0-.185-.186h-2.12a.186.186 0 0 0-.185.186v1.887c0 .102.084.185.186.185m-2.92 0h2.12a.185.185 0 0 0 .184-.185V9.006a.185.185 0 0 0-.184-.186h-2.12a.185.185 0 0 0-.184.185v1.888c0 .102.082.185.185.185M23.763 9.89c-.065-.051-.672-.51-1.954-.51-.338.001-.676.03-1.01.087-.248-1.7-1.653-2.53-1.716-2.566l-.344-.199-.226.327c-.284.438-.49.922-.612 1.43-.23.97-.09 1.882.403 2.661-.595.332-1.55.413-1.744.42H.751a.751.751 0 0 0-.75.748 11.376 11.376 0 0 0 .692 4.062c.545 1.428 1.355 2.48 2.41 3.124 1.18.723 3.1 1.137 5.275 1.137.983.003 1.963-.086 2.93-.266a12.248 12.248 0 0 0 3.823-1.389c.98-.567 1.86-1.288 2.61-2.136 1.252-1.418 1.998-2.997 2.553-4.4h.221c1.372 0 2.215-.549 2.68-1.009.309-.293.55-.65.707-1.046l.098-.288z"/>
      </svg>
    ),
    command: "docker run --rm -v \"./src:/src\" shivasurya/code-pathfinder:stable-latest scan --ruleset python/django --project /src",
    note: "Container-based scanning • Includes all dependencies",
  },
];

export default function InstallationTabs() {
  const [activeTab, setActiveTab] = useState<TabId>("brew");
  const [copied, setCopied] = useState(false);

  const activeTabData = tabs.find((tab) => tab.id === activeTab)!;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(activeTabData.command);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      {/* Tab buttons */}
      <div className="flex border-b border-gray-200 overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-3 sm:px-6 py-3 text-sm font-medium transition-colors border-b-2 -mb-px whitespace-nowrap ${
              activeTab === tab.id
                ? "text-gray-900 border-lime-500"
                : "text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300"
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Command display */}
      <div className="mt-4 relative group">
        <div className="bg-gray-900 rounded-lg p-4 font-mono text-sm text-gray-100 flex items-center justify-between">
          <code>{activeTabData.command}</code>
          <button
            onClick={copyToClipboard}
            className="ml-4 p-2 rounded-md hover:bg-gray-700 transition-colors text-gray-400 hover:text-white"
            title="Copy to clipboard"
          >
            {copied ? (
              <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            )}
          </button>
        </div>
        {activeTabData.note && (
          <p className="mt-2 text-sm text-gray-500 text-center">{activeTabData.note}</p>
        )}
      </div>
    </div>
  );
}
